<template>
  <div class="h-full flex flex-col min-h-0">
    <viewer
      :options="viewerOptions"
      :images="specimenImages"
      @inited="inited"
      class="viewer browser browser-sm browser-lg flex-1 h-full w-full relative"
      ref="viewer"
    >
      <template v-slot="scope">
        <span v-if="stateOfCheck">
          <div
            v-for="src in scope.images"
            :key="src"
          >
            <img @click="show" :src="src" alt="標本縮圖" style="width:0">
          </div>
        </span>
        <span v-else>
          <img @click="show" src="@/assets/alternative_image.jpg" alt="標本預設縮圖" style="width:0">
        </span>
      </template>
    </viewer>
  </div>
</template>

<script>
export default {
  name: "ImageViewer",
  props: ["specimenData"],
  data() {
    return {
      viewerOptions: {
        toolbar: true,
        inline: true,
        zoomOnWheel: false,
        title () {
          if (this.index === 0) {
            return "Specimen Images (" + (this.index + 1) + "/" + this.length + ")"
          } else if (this.index === 1) {
            return "Label Images (" + (this.index + 1) + "/" + this.length + ")"
          } else {
            return "Attachment Images (" + (this.index + 1) + "/" + this.length + ")"
          }
        }
      },
      stateOfCheck: 0,
      specimenImages: [],
      imagesSamples: [
        "https://picsum.photos/200/200",
        "https://picsum.photos/300/200",
        "https://picsum.photos/250/200"
      ]
    };
  },
  mounted() {
    this.stateOfCheck = this.specimenData.state_of_check
    if (this.stateOfCheck) {
      this.specimenImages.push(this.specimenData.pic_150_url)
      this.specimenImages.push(this.specimenData.label_url)
      this.specimenData.attachments.forEach(item => {
        this.specimenImages.push(item.pic_150_url)
      })
    } else {
      this.specimenImages.push("@/assets/browser.jpg")
    }
  },
  methods: {
    // v-viewer function
    inited (viewer) {
      this.$viewer = viewer
    },
    show () {
      this.$viewer.show()
    }
  },
}
</script>

<style scoped>
@media (min-width: 1024px) {
  .browser-lg {
    height: 100%;
    min-height: 500px;
  }
}
@media (min-width: 640px) and (max-width: 1023.98px) {
  .browser-sm {
    height: 500px;
  }
}

@media (max-width: 639.98px) {
  .browser {
    height: 300px;
  }
}
</style>
